import { Center, Loader } from "@mantine/core";

export const PageLoading = () => {
    return (
        <Center mih="calc(100vh - 150px)">
            <Loader color="pink" size="xl" type="dots" />
        </Center>
    );
};
